import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { OrderDetailsComponent } from './order-details.component';
import { ToastModule } from 'primeng';

const routes: Routes = [
  { path: '', component: OrderDetailsComponent, data: { title: 'Order Details' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrderDetailsRoutingModule {}

@NgModule({
  imports: [
    OrderDetailsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    ToastModule,
  ],
  declarations: [OrderDetailsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OrderDetailsModule {}
